import { useAuth0 } from '@auth0/auth0-react';
import { useMemo } from 'react';
import { useParams } from 'react-router';
import useSWR from 'swr';
import { RecruitmentSpecificationDTO } from '@/DTO/Assessments/RecruitmentSpecificationDTO';
import http from '@/Utils/HTTP/NewHttpUtils';

const useRecruitmentSpec = (assessmentIdParameter?: string) => {
    const { assessmentId: assessmentIdUrl } = useParams();
    const assessmentId = useMemo(() => assessmentIdParameter || assessmentIdUrl!, []);
    const { getAccessTokenSilently } = useAuth0();

    return useSWR(`recruitments/${assessmentId}/specification`, async (path) => {
        const response = await http.get<RecruitmentSpecificationDTO>({
            path,
            accessToken: await getAccessTokenSilently(),
        });
        return response;
    });
};

export default useRecruitmentSpec;
